import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';
import { primary } from '@/theme/colors';
import { Box } from '@mui/material';

export const Overlay = styled.div`
  margin-top: 40px;
  margin-bottom: 16px;
  width: 100%;
  overflow: hidden;
  cursor: grab;
  position: relative;

  svg {
    position: absolute;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
  }
`;

export const OverlayImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform-origin: top left;
`;

export const HeatmapSvg = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform-origin: top left;
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
`;

export const PaintRegionSvg = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform-origin: top left;
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
`;

export const zoomButtonStyles = {
  opacity: '0.7',
  borderRadius: '4px',
  minWidth: 0,
  width: 'auto',
};

export const ZoomButtonsBoxStyles = {
  position: 'absolute',
  bottom: 0,
  right: 0,
  height: '40px',
  width: '100px',
  display: 'flex',
  justifyContent: 'center',
  borderRadius: 2,
  padding: '10px 20px',
  backgroundColor: 'black',
  gap: '15px',
};

export const ErrorContainer = styled.div`
  top: 45%;
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    width: 26%;
    text-align: center;
  }
`;

export const SphericalButton = muiStyled(Box)(() => ({
  background: primary.blue,
  width: '24px',
  height: '24px',
  borderRadius: '2px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
}));
